if (!customElements.get('shipping-checkbox')) {
  class ShippingCheckbox extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (this.checkbox) {
        this.cartDrawer = document.querySelector('cart-drawer');
        this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));

        // Initialize the checkbox state based on cart content
        this.updateCheckboxState();
      }

      // Listen for cart updates and refresh the checkbox state
      document.addEventListener('dispatch:cart-drawer:refresh', () => {
        this.updateCheckboxState();
      });
    }

    /**
     * Handles checkbox change event to add/remove insurance from the cart.
     * @param {object} evt - Event object.
     */
    async handleCheckboxChange(evt) {
      if (evt.target.checked) {
        await this.addInsuranceToCart();
      } else {
        await this.removeInsuranceFromCart();
      }
      setTimeout(async function() {
        const cart = await fetch('/cart.js').then((res) => res.json());
        updateProgress(cart.original_total_price)
      });
    }

    /**
     * Adds insurance product to the cart if non-gift card products are present.
     */
    async addInsuranceToCart() {
      try {
        // Fetch the current cart
        const cart = await fetch('/cart.js').then((res) => res.json());

        // Check if insurance is already in the cart
        const insuranceItem = cart.items.find((item) => item.id === 40710165004349); // Replace with actual insurance product ID
        if (insuranceItem) {
          console.log('Insurance is already in the cart.');
          return; // Don't add again if it's already in the cart
        }
        
        // Check if there's any non-gift card product in the cart
        const hasNonGiftCardProduct = cart.items.some((item) => !item.gift_card);
        // If no non-gift card product is found, don't add insurance
        if (!hasNonGiftCardProduct) {
          this.checkbox.checked = false;
          console.log('No non-gift card product in the cart, insurance will not be added.');
          alert('gift card product in the cart, insurance will not be added.');
          return;
        }

        // Proceed to add insurance if a non-gift card product is found
        const formData = new FormData();
        formData.append('id', '40710165004349'); // Replace with actual insurance product ID
        formData.append('quantity', 1);

        let sections = 'cart-icon-bubble';
        if (this.cartDrawer) {
          sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sections);

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        };

        const response = await fetch('/cart/add.js', fetchRequestOpts);
        if (!response.ok) throw new Error(response.statusText);

        const data = await response.json();

        this.updateCartIcon(data);
        const quickAddDrawer = this.closest('quick-add-drawer');
        if (quickAddDrawer) quickAddDrawer.addedToCart();
        setTimeout(() => {
          if (this.cartDrawer) {
            this.cartDrawer.renderContents(data, !quickAddDrawer && theme.settings.afterAtc === 'drawer');
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
        }, 700);

        console.log('Insurance added to cart');
      } catch (error) {
        console.error('Error adding insurance:', error);
      }
    }

    /**
     * Removes insurance product from the cart.
     */
    async removeInsuranceFromCart() {
      try {
        const cart = await fetch('/cart.js').then((res) => res.json());
        const insuranceItem = cart.items.find((item) => item.id === 40710165004349); // Replace with actual ID

        if (insuranceItem) {
          const formData = new FormData();
          formData.append('id', insuranceItem.id);
          formData.append('quantity', 0);

          const fetchRequestOpts = {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          };

          const response = await fetch('/cart/change.js', fetchRequestOpts);
          const data = await response.json();
          console.log('Insurance removed from cart');
          if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                cartItems.refresh();
              }
            }
          }
          else{  
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
            bubbles: true
          }));
          }
        }
      } catch (error) {
        console.error('Error removing insurance:', error);
      }
    }

    /**
     * Updates the checkbox state based on whether the insurance product is in the cart.
     */
    async updateCheckboxState() {
      try {
        const cart = await fetch('/cart.js').then((res) => res.json());
        
        // Replace with actual insurance product ID
        const insuranceItem = cart.items.find((item) => item.id === 40710165004349); 
    
        // Set checkbox state based on the presence of the insurance item in the cart
        this.checkbox.checked = !!insuranceItem; // Convert to boolean
        if (!insuranceItem) {
      // Make sure the checkbox is unchecked if insurance is not present
      this.checkbox.checked = false;
    }
      } catch (error) {
        console.error('Error updating checkbox state:', error);
      }
    }

    /**
     * Updates the cart icon count.
     * @param {object} response - Response JSON.
     */
    updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && response.sections) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }
  }

  customElements.define('shipping-checkbox', ShippingCheckbox);
}
